import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { useIntl } from 'react-intl'
import { history } from '../../../_state/helpers'
import OrganizationOverviewSidebar from './Components/OrganizationOverviewSidebar'
import CourseStatisticsTabBar, { CourseStatisticsTab } from '../../../Components/CourseStatistics/CourseStatisticsTabBar'
import CourseFindUsersContent from '../../../Components/CourseStatistics/CourseFindUsersContent'
import { i18nMessages } from '../../../Logic/CodeAccessible.i18n.Messages'

const useStyles = makeStyles(() => ({
    root: {
        minHeight: '300px',
        marginLeft: 'calc(15% + 25px)',
        marginRight: '25px',
        paddingBottom: '60px',
    },
    backButton: {
        marginTop: '16px',
        textTransform: 'none',
    },
}))

/**
 * Organization wide "find users". A sibling page of the course statistics tab rather than a third
 * tab: the tabs are views of an organization's statistics, and this is an action taken from one of
 * them. A tab would advertise a page that names individuals as though it were a routine view.
 */
const OrganizationCourseFindUsers = (props) => {
    const classes = useStyles()
    const intl = useIntl()
    const location = useLocation()

    // Scope travels in the query string rather than router state, so the page survives a refresh
    // and can be pasted to a colleague.
    const searchParams = new URLSearchParams(location.search)
    const initialCourseGroupId = searchParams.get('courseGroupId')
    const initialTopicIdRaw = searchParams.get('topicId')
    const initialTopicId = initialTopicIdRaw ? Number(initialTopicIdRaw) : null

    const currentOrganization = props.organization.myOrganizations?.find(
        (x) => x.id === props.organization.selectedOrganization
    )

    const goToCourseStatistics = () => history.push('/dashboard/statistics/courses')

    return (
        <div className={classes.root}>
            <OrganizationOverviewSidebar path={props.computedMatch?.path} />
            <CourseStatisticsTabBar
                activeTab={CourseStatisticsTab.Courses}
                onChange={(tab) => {
                    history.push(tab === CourseStatisticsTab.Overview ? '/dashboard/statistics' : '/dashboard/statistics/courses')
                }}
            />

            <Button className={classes.backButton} startIcon={<ArrowBackIcon />} onClick={goToCourseStatistics}>
                {intl.formatMessage(i18nMessages.courseStatisticsBackToCourses)}
            </Button>

            <CourseFindUsersContent
                organizationId={props.organization.selectedOrganization}
                initialCourseGroupId={initialCourseGroupId}
                initialTopicId={initialTopicId}
                scopeName={currentOrganization?.name}
            />
        </div>
    )
}

function mapStateToProps(state) {
    const { organization, user } = state
    return {
        organization,
        user,
    }
}

export default connect(mapStateToProps)(OrganizationCourseFindUsers)
